import React from "react";
import { Spinner } from "@homy/ui";

export function LoadingFallback({ className = "" }) {
  return (
    <div
      role="status"
      aria-label="Loading page"
      className={`flex min-h-[50vh] w-full items-center justify-center bg-transparent ${className}`}
    >
      <Spinner size="lg" />
    </div>
  );
}

export default LoadingFallback;
